<script setup lang="ts">
import { computed, watch } from "vue";
import { useRouter } from "vue-router";
import { DialogClose, DialogContent, DialogOverlay, DialogPortal, DialogRoot, DialogTitle } from "reka-ui";

import { useCaseRouteParams } from "@/hooks/use-case-route-params";

import { useBrandSecurityStore, useCaseSecurityStore } from "@/stores";

import { $can } from "@/services/UtilitiesService";

import CaseDetailsAccess from "@/components/CasePanels/CaseDetails/Access/Access.vue";

const router = useRouter();

const routeParams = useCaseRouteParams();

const canManageAccess = computed(
  () => useBrandSecurityStore().config?.isCaseSecurityEnabled === true && ($can("manageAccess") || $can("auditAccess")),
);

watch(
  [canManageAccess, () => routeParams.value.client],
  () => {
    if (canManageAccess.value) useCaseSecurityStore().load();
    else router.push({ name: "brand", params: { brand: routeParams.value.brand } });
  },
  { immediate: true },
);
</script>
<template>
  <DialogRoot
    default-open
    @update:open="(open) => !open && router.push({ name: 'brand', params: { brand: routeParams.brand } })"
  >
    <DialogPortal>
      <DialogOverlay class="tw-fixed tw-inset-0 tw-z-[1000000] tw-h-full tw-w-full tw-bg-black/30" />
      <DialogContent
        :aria-describedby="undefined"
        class="tw-fixed tw-inset-0 tw-z-[1000000] tw-flex tw-items-center tw-justify-center"
      >
        <div
          class="tw-flex tw-size-full tw-max-h-[80vh] tw-max-w-[80vw] tw-flex-col tw-space-y-2 tw-rounded-lg tw-border tw-bg-white tw-p-4 tw-shadow-lg"
        >
          <DialogTitle class="tw-text-balance tw-text-center tw-text-lg tw-font-semibold">
            Case Access ({{ routeParams.casename }})
          </DialogTitle>
          <div class="tw-flex tw-items-center tw-justify-end">
            <DialogClose type="button" class="tw-btn-lg-gray invert tw-flex tw-items-center tw-gap-2">
              <i aria-hidden="true" class="fas fa-xmark" />
              Close
            </DialogClose>
          </div>
          <CaseDetailsAccess />
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
